import { useFeature } from "./useFeatures"

export const useIsOrderChangeable = (status?: string) => {
  const [allowChangeRequestIfConfirmed] = useFeature('order.allowChangeRequestIfConfirmed')
  if (!status) return false
  if (['pending', 'inspection_pending'].includes(status)) return true
  if (allowChangeRequestIfConfirmed && status === 'confirmed') return true
  return false
}
